module.exports = __webpack_public_path__ + "img/yl3031.184eca42.png";